<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {}
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}

@font-face {
  font-family: HarmonyOS Sans;
  src: url('./font/HarmonyOS_Sans_Bold.ttf');
}

.insure-box {
  width: 360px;
  background-color: transparent;
}

.close-img {
  width: 24px !important;
  height: 24px;
  margin: 36px auto 0;
}

.count-down-time {
  position: absolute;
  left: 50%;
  bottom: 25px;
  transform: translate(-50%, 0);
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 400;
}

.count-down-box {
  position: relative;
}


.wximage {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 99999;

  img {
    width: 100%;
    height: 100%;
  }
}

.line-center {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
</style>
